import { render, staticRenderFns } from "./MindsetInformation.vue?vue&type=template&id=ae3b6720&"
import script from "./MindsetInformation.vue?vue&type=script&lang=ts&"
export * from "./MindsetInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports